import { SquirrelCrossing } from './components/Game/SquirrelCrossing';

function App() {
  return (
    <SquirrelCrossing />
  );
}

export default App;
